module.exports = __webpack_public_path__ + "static/media/puerta-sala-frida.7fdc4fe6.jpg";